import { render } from "./TabHealth.vue?vue&type=template&id=3d49c321&ts=true"
import script from "./TabHealth.vue?vue&type=script&lang=ts"
export * from "./TabHealth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__